import { AnyType } from '@src/models/common';

export const JSONParseCatch = (text: string) => {
  let hasError = false;
  let result: AnyType = null;

  try {
    result = JSON.parse(text);
  } catch (error) {
    hasError = true;
  }

  return { hasError, result };
};
